function closePopupEvent() {
  closePopupElements.forEach((closePopupElement) => {
    closePopupElement.addEventListener('click', (event) => {
      hidePopup();
    });
  });
}

function openPopupEvent() {
  openPopupElements.forEach((openPopupElement) => {
    openPopupElement.addEventListener('click', (event) => {
      showPopup();
    });
  });
}

function continuePopupEvent() {
  if (!acceptButton) return;

  acceptButton.addEventListener('click', () => {
    hidePopup();
  });
}

function hidePopup() {
  // Remove the visible attribute
  popup.closest('.shopify-section').removeAttribute('visible');
  // Hide the popup
  popup.closest('.shopify-section').setAttribute('hidden', '');
}

function showPopup() {
  // Close nav if it's open
  const closeNavButton = document.querySelector('#header-sidebar-menu button[is="close-button"]');
  if (closeNavButton) closeNavButton.click();

  // Remove the visible attribute
  popup.closest('.shopify-section').removeAttribute('hidden');
  // Hide the popup
  popup.closest('.shopify-section').setAttribute('visible', '');
}

// Globals
const popup = document.querySelector('.trellis-redirect-popup');
const closePopupElements = document.querySelectorAll('.trellis-redirect-popup__button-deny');
const acceptButton = document.querySelector('.trellis-redirect-popup__button-accept');
const openPopupElements = document.querySelectorAll('a[href="#hcp-modal"]');

// Page load functions
openPopupEvent();
closePopupEvent();
continuePopupEvent();
